import { render, staticRenderFns } from "./ClienteFormModal.vue?vue&type=template&id=31af0a3e&scoped=true"
import script from "./ClienteFormModal.vue?vue&type=script&lang=js"
export * from "./ClienteFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClienteFormModal.vue?vue&type=style&index=0&id=31af0a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af0a3e",
  null
  
)

export default component.exports